/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React, { Component } from "react";

const Dialog = require("@react/react-spectrum/Dialog").default;

class SaveOrCancelDialog extends Component {
  render() {
    const formatMessage = this.props.intl.formatMessage;
    const title = this.props.title || "dialog.print.title";
    return (
      <Dialog
        title={formatMessage({ id: title })}
        onConfirm={this.props.downloadPDF}
        onClose={this.props.cancelDialog}
        confirmLabel={formatMessage({ id: "common.download" })}
        cancelLabel={formatMessage({ id: "common.cancel" })}
        autoFocusButton="confirm"
      >
        <p>{formatMessage({ id: "dialog.print.text" })}</p>
      </Dialog>
    );
  }
}

export { SaveOrCancelDialog };
